import {
  MapSettingsToolsStateActiveTool, type MapSettingsToolsStateActiveToolState,
} from './mapSettingsToolsStateActiveTool.state';

type ResolveActiveToolParams = {
  activeTool: MapSettingsToolsStateActiveToolState;
  isDataLayersEnabled: boolean;
  hasDataLayers: boolean;
  areBTGsLoaded: boolean;
  hasBoundaryToolBTGs: boolean;
  isMapPresentational: boolean;
  isImageExport: boolean;
};

// If the active tool is not set (yet), it is determined from the map content:
// Data Layers if there are data layers but the boundary tool is empty, Boundary otherwise
export const resolveActiveTool = ({
  activeTool, isDataLayersEnabled, hasDataLayers, areBTGsLoaded, hasBoundaryToolBTGs, isMapPresentational, isImageExport,
}: ResolveActiveToolParams): MapSettingsToolsStateActiveTool => {
  if ((activeTool === MapSettingsToolsStateActiveTool.DataLayers && !isDataLayersEnabled)
    || (isMapPresentational && !isImageExport)) {
    return MapSettingsToolsStateActiveTool.Boundary; // a persisted tool the user is not entitled to (anymore)
  }

  if (activeTool) {
    return activeTool;
  }

  const isBoundaryToolEmpty = areBTGsLoaded && !hasBoundaryToolBTGs;

  return isDataLayersEnabled && hasDataLayers && isBoundaryToolEmpty
    ? MapSettingsToolsStateActiveTool.DataLayers
    : MapSettingsToolsStateActiveTool.Boundary;
};
